import { adminHttpClient } from '../../commons/adminHttpClient'
import { WizardDto } from '../common/models'

const ichraWizardApi = (): Promise<WizardDto> => {
  return adminHttpClient.get('/AdminSignup/ichra/Wizard')
}

export default ichraWizardApi
